/**
 * Cursor: rules are files (`.cursor/rules/*.mdc` with frontmatter,
 * `.cursorrules`, `AGENTS.md`); Memories have no export and ride the paste
 * lane. Rules are how-to by nature → epistemic 'procedure' throughout.
 */
import { chunkMarkdown } from '../chunk.js';
import type { MemoryImportItem, NamedText } from '../types.js';
import { plainTextItems } from './generic.js';
import { basename, frontmatterDescription } from './util.js';

export function parseCursor(files: NamedText[]): MemoryImportItem[] {
  const items: MemoryImportItem[] = [];
  for (const file of files) {
    const base = basename(file.name).toLowerCase();
    if (/\.mdc$/i.test(file.name)) {
      const description = frontmatterDescription(file.text);
      if (description) items.push(...plainTextItems(description, { epistemic: 'procedure', sourceDetail: basename(file.name) }));
      items.push(...chunkMarkdown(file.text, basename(file.name), { epistemic: 'procedure' }));
    } else if (base === '.cursorrules' || base === 'agents.md') {
      items.push(...chunkMarkdown(file.text, basename(file.name), { epistemic: 'procedure' }));
    }
  }
  return items;
}
